import { Component, Input } from "@angular/core";
import { Tab } from "common/tab/tab.interface";
import { ToolbarItem } from "common/toolbar/toolbar-item.interface";

@Component({
	selector: "stages-tab-card",
	templateUrl: "./tab-card.component.html",
})
export class TabCardComponent {
	@Input()
	showTabs: boolean = true;

	@Input()
	tabs?: Tab[];

	@Input()
	toolbarItems?: ToolbarItem[];

	@Input()
	toolbarId?: string;

	@Input()
	menuId?: string;

	@Input()
	menuItems?: MenuItem[];

	@Input()
	menuNoCollapse?: boolean;

	@Input()
	hideSingleTab?: boolean;

	protected _showTabs = true;

	get areTabTitlesVisible(): boolean {
		if (!this.tabs) {
			return false;
		} else if (this.hideSingleTab) {
			return this.tabs.length > 1;
		} else {
			return this.tabs.length > 0;
		}
	}
}
